import React from "react";
import { FormControl, Select, MenuItem, InputAdornment } from "@mui/material";
import globalStyle from "./../../globalStyle";

const CustomDropDown = ({ icon, children, onChange, ...props }) => {
  return (
    <FormControl fullWidth sx={globalStyle.textField}>
      <Select
        startAdornment={
          <InputAdornment position="start">{icon && icon}</InputAdornment>
        }
        {...props}
        onChange={onChange}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default CustomDropDown;
